// src/components/Chatbot.jsx
import { useState } from "react"

const Chatbot = () => {
  const [messages, setMessages] = useState([])
  const [userInput, setUserInput] = useState("")
  const [loading, setLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const handleSend = async () => {
    if (!userInput.trim()) return

    const newMessage = { sender: "user", text: userInput }
    setMessages((prev) => [...prev, newMessage])
    setUserInput("")
    setLoading(true)

    try {
      const response = await fetch("https://back-jaypastry-6b39278fcdf9.herokuapp.com/chatbot", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userInput }),
      })

      const data = await response.json()
      const botMessage = { sender: "bot", text: data.reply }
      setMessages((prev) => [...prev, botMessage])
    } catch (error) {
      setMessages((prev) => [...prev, { sender: "bot", text: "Erreur de connexion avec l'assistant." }])
    }

    setLoading(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSend()
    }
  }

  return (
    <div className="chatbot-container">
      <button className="chatbot-toggle" onClick={() => setIsOpen(!isOpen)}>
        💬
      </button>

      {isOpen && (
        <div className="chatbot-box">
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`chatbot-msg ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
            {loading && <div className="chatbot-msg bot">⏳ Assistant répond...</div>}
          </div>

          <div className="chatbot-input">
            <input
              type="text"
              placeholder="Posez votre question..."
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button onClick={handleSend}>Envoyer</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Chatbot
